<div
  class="progress-bar-container"
  [class.text-inside]="textInside()"
  [class.indeterminate]="indeterminate()"
  [style.--progress-ratio]="ratio()"
  [attr.role]="exposed() ? 'progressbar' : null"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-labelledby]="labelledBy()"
  [attr.aria-valuemin]="exposed() ? 0 : null"
  [attr.aria-valuemax]="exposed() ? 100 : null"
  [attr.aria-valuenow]="ariaValueNow()"
  [attr.aria-valuetext]="exposed() ? valueText() : null">
  <div class="progress-bar-fill" [style.width.%]="indeterminate() ? null : percentage()"></div>
  @if (textInside()) {
    <span class="progress-bar-text" [id]="textId">
      <ng-content></ng-content>
    </span>
  }
</div>
